import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("lumen_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me")
            .then(r => setUser(r.data))
            .catch(() => localStorage.removeItem("lumen_token"))
            .finally(() => setLoading(false));
    }, []);

    const setSession = (token, userData) => {
        localStorage.setItem("lumen_token", token);
        setUser(userData);
    };

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setSession(data.token, data.user);
        return data.user;
    };

    const register = async (email, password, name) => {
        const { data } = await api.post("/auth/register", { email, password, name });
        setSession(data.token, data.user);
        return data.user;
    };

    const exchangeSession = async (sessionId) => {
        const { data } = await api.post("/auth/session", null, {
            headers: { "X-Session-ID": sessionId }
        });
        setSession(data.token, data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("lumen_token");
        setUser(null);
    };

    const refresh = async () => {
        try {
            const r = await api.get("/auth/me");
            setUser(r.data);
            return r.data;
        } catch (e) { void e; return null; }
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, login, register, exchangeSession, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
